import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import FormControl from '@mui/material/FormControl'
import FormControlLabel from '@mui/material/FormControlLabel'
import FormLabel from '@mui/material/FormLabel'
import InputLabel from '@mui/material/InputLabel'
import MenuItem from '@mui/material/MenuItem'
import Radio from '@mui/material/Radio'
import RadioGroup from '@mui/material/RadioGroup'
import Select from '@mui/material/Select'
import TextField from '@mui/material/TextField'
import React, { useEffect, useState } from 'react'
import {
  ASSET_CLASS_URL,
  ASSET_ITEM_URL,
  ASSET_STATUS_URL,
  ASSET_TYPE_CLASS_URL,
  ORG_URL,
  USERS_URL,
  DEPARTMETNS_URL,
  ASSET_DISABLE_METHODS_URL,
  ASSET_ASSIGNMENT_TYPES_URL,
  ASSET_WAREHOUSE_URL,
  ASSET_LOST_TYPE_URL,
  ASSET_MAINTENANCE_TYPE_URL

} from "../../Constants/Constants";

import AxiosInstance from "../../services/AxiosInstance";
import { ThemeProvider } from "../v2/home/theme/ThemeProvider";
import AddTaskIcon from "@mui/icons-material/AddTask";
import SaveIcon from "@mui/icons-material/Save";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import { useAlert } from "./../alerts/AlertContext";
import { Link } from "react-router-dom";
import { isEmpty } from "../../Constants/RolesConstants";
import { STATUS_FIELDS } from "./AssetStatusConfig";
import Typography from "@mui/material/Typography";
import DynamicAssetField from "./DynamicAssetField";

function AssetItemDialog({
  assetItemId,
  selectedItemName,
  callAssetItems,
  actionType,
  isEdit,
  componentPermissions = {},
}) {
  const [open, setOpen] = React.useState(false);
  const [itemName, setItemName] = useState("");
  const [location, setLocation] = useState("");
  const [desc, setDesc] = useState("");
  const [assetStatus, setAssetStatus] = useState();
  const [assetStatuses, setAssetStatuses] = useState([]);

  const [assetClass, setAssetClass] = useState();
  const [assetClasses, setAssetClasses] = useState([]);

  const [assetType, setAssetType] = useState("")
  const [assetTypes, setAssetTypes] = useState([])

  const [assignedUser, setAssignedUser] = useState()
  const [assignedUsers, setAssignedUsers] = useState([]);
  const [assetTag, setAssetTag] = useState("");

  const [department, setDepartment] = useState()
  const [departments, setDepartments] = useState([]);

  const [organization, setOrganization] = useState();
  const [organizations, setOrganizations] = useState([]);

  const [assignmentType, setAssignmentType] = useState();
  const [assignmentTypes, setAssignmentTypes] = useState([]);
  const [disposalMethod, setDisposalMethod] = useState();
  const [disposalMethods, setDisposalMethods] = useState([]);

  const [warehouseName, setWarehouseName] = useState();
  const [warehouseNames, setWarehouseNames] = useState([]);

  const [vendor, setVendor] = useState();
  const [vendors, setVendors] = useState([]);

  const [lostType, setLostType] = useState();
  const [lostTypes, setLostTypes] = useState([]);


  const [maintenanceType, setMaintenanceType] = useState();
  const [maintenanceTypes, setMaintenanceTypes] = useState([]);

  const showAlert = useAlert()

  const INITIAL_ASSET_FORM = {
    name: "",
    assetClassId: "",
    assetTypeId: "",
    organizationId: "",
    userId: "",
    description: "",
    assetStatusId: "",
    assetTag: "",
    resolverGroup: "",
    operationalStatus: "",
    location: "",
    hostName: "",
    makeModel: "",
    year: "",
    serial: ""
  };

  const INITIAL_LIFECYCLE_FORM = {};
  const [formData, setFormData] = useState(INITIAL_ASSET_FORM);
  const [lifecycleData, setLifecycleData] = useState(
    INITIAL_LIFECYCLE_FORM
  );

  const selectedStatus = React.useMemo(() => {
    if (!assetStatuses?.length || !formData?.assetStatusId) {
      return null;
    }

    return assetStatuses.find(
      status =>
        Number(status?.id) ===
        Number(formData.assetStatusId)
    ) || null;
  }, [assetStatuses, formData?.assetStatusId]);

  const selectedStatusCode =
    selectedStatus?.statusCode || "";

  const dynamicFields =
    STATUS_FIELDS?.[selectedStatusCode] || [];

  // Find selected status
  // const selectedStatus = assetStatuses?.find(
  //   status =>
  //     Number(status?.id) ===
  //     Number(formData?.assetStatusId)
  // );

  // Get status code
  // const selectedStatusCode =
  //   selectedStatus?.statusCode;

  // Get fields for selected status
  // const dynamicFields =
  //   STATUS_FIELDS[selectedStatusCode] || [];

  const [assetItem, setAssetItem] = useState({
    name: '',
    description: '',
    assetClass: {},
    assetType: {},
    organization: {},
    user: {},
    assetStatus: {},
    location: '',
    assetTag: ''
  })

  useEffect(() => {
    getAssetClasses();
    getAssignedUsers();
    getOrganizations();
    getAssetStatus();
    getDepartments();
    getAssignmentTypes();
    getDisposalMethods();
    getWarehouseNames();
    getVendors();
    getLostTypes();
    getMaintenanceTypes();

  }, [])

  const handleClickOpen = () => {
    if (isEdit === true) {
      getAssetItem();
    } else {
      setOpen(true);
    }

  };

  const handleClose = () => {
    setOpen(false)
  }

  const handleAssetTypeNameChange = (event) => {
    setItemName(event.target.value);
  };

  const handleLocationChange = (event) => {
    setLocation(event.target.value);
  };

  const handleAssignedUserChange = (event) => {
    setAssignedUser(event.target.value)
  }

  const handleOrganizationChange = (event) => {
    setOrganization(event.target.value)
  }

  const handleAssetStatusChange = (event) => {
    setAssetStatus(event.target.value);
    const statusId = Number(event.target.value);

    setFormData(prev => ({
      ...prev,
      assetStatusId: statusId
    }));

    setLifecycleData({});
  }

  const handleLifecycleChange = (event) => {

    const { name, value } = event.target;

    setLifecycleData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleDescriptionChange = (event) => {
    setDesc(event.target.value)
  }

  const handleAssetTagChange = (event) => {
    setAssetTag(event.target.value)
  }


  const getAssetClasses = () => {
    AxiosInstance.get(ASSET_CLASS_URL).then((response) =>
      setAssetClasses(response.data.data)
    )
  }

  const getAssignedUsers = () => {
    AxiosInstance.get(USERS_URL).then((response) =>
      setAssignedUsers(response.data.data)
    )
  }

  const getOrganizations = () => {
    AxiosInstance.get(ORG_URL).then((response) =>
      setOrganizations(response.data.data)
    )
  }

  const getAssetStatus = () => {
    AxiosInstance.get(ASSET_STATUS_URL).then((response) =>
      setAssetStatuses(response.data)
    )
  }

  const getDepartments = () => {
    AxiosInstance.get(DEPARTMETNS_URL).then((response) =>
      setDepartments(response.data.data)
    )
  }

  const getAssignmentTypes = () => {
    AxiosInstance.get(`${ASSET_ASSIGNMENT_TYPES_URL}/all`).then((response) =>
      setAssignmentTypes(response.data)
    )
  }

  const getDisposalMethods = () => {
    AxiosInstance.get(`${ASSET_DISABLE_METHODS_URL}/all`).then((response) =>
      setDisposalMethods(response.data)
    )
  }

  const getWarehouseNames = () => {
    AxiosInstance.get(`${ASSET_WAREHOUSE_URL}`).then((response) =>
      setWarehouseNames(response.data)
    )
  }

  const getVendors = () => {
    AxiosInstance.get(`${ORG_URL}/vendor`).then((response) =>
      setVendors(response.data.data)
    )
  }

  const getLostTypes = () => {
    AxiosInstance.get(`${ASSET_LOST_TYPE_URL}`).then((response) =>
      setLostTypes(response.data)
    )
  }

  const getMaintenanceTypes = () => {
    AxiosInstance.get(`${ASSET_MAINTENANCE_TYPE_URL}`).then((response) =>
      setMaintenanceTypes(response.data)
    )
  }



  const handleAssetClassChange = async (event) => {
    setAssetClass(event.target.value)

    if (event.target?.value) {
      await AxiosInstance.get(
        `${ASSET_TYPE_CLASS_URL}/${event.target.value}`
      ).then((response) => {
        setAssetTypes(response.data.data)
      })
    }
  }

  const handleAssetTypeChange = (event) => {
    setAssetType(event.target.value)
  }

  const handleSave = () => {
    const payload = {};
    payload.name = itemName;
    payload.assetClass = { id: assetClass };
    payload.assetType = { id: assetType };
    payload.organization = { id: organization };
    payload.user = { id: assignedUser };
    payload.description = desc;
    payload.assetStatus = { id: assetStatus };
    payload.location = location;
    payload.assetTag = assetTag;
    payload.department = { id: department };
    payload.disposalMethod = { id: disposalMethod };
    payload.assignmentType = { id: assignmentType };
    payload.statusDetails = lifecycleData;



    if (isEdit) {
      updateAssetItem(payload);
    } else {
      saveAssetItem(payload);
    }
  };

  const saveAssetItem = async (payload) => {
    if (assetItemId !== "")
      assetItem.id = assetItemId;

    await AxiosInstance.post(ASSET_ITEM_URL, payload)
      .then((response) => {
        showAlert('Asset Item created successfully!', 'success')
        callAssetItems()
      })
      .catch((error) => {
        showAlert('Asset Item creation failed!', 'error')
        console.error(error)
      })
  }

  const updateAssetItem = async (payload) => {
    if (assetItemId !== "")
      assetItem.id = assetItemId;

    await AxiosInstance.put(`${ASSET_ITEM_URL}/${assetItemId}`, payload)
      .then((response) => {
        showAlert('Asset Item updated successfully!', 'success')
        callAssetItems()
      })
      .catch((error) => {
        showAlert('Asset Item updation failed!', 'error')
        console.error(error)
      })
  }

  const getDynamicFieldValue = (field, value) => {

    if (value == null || value === "") {
      return "";
    }

    if (
      field.type === "date" ||
      field.type === "datetime-local"
    ) {
      return String(value).substring(0, 10);
    }

    return value;
  };

  const getAssetItem = () => {
    // TODO: server side pagination isn't implemented in server yet, so this will be currently client side pagination
    AxiosInstance.get(`${ASSET_ITEM_URL}/${assetItemId}`).then((response) => {
      //setData(response.data)
      var itemData = response.data.data;
      setAssetClass(itemData.assetClass?.id ?? "");

      if (itemData.assetClass?.id) {
        AxiosInstance.get(`${ASSET_TYPE_CLASS_URL}/${itemData.assetClass?.id}`).then(
          (res) => {
            const types = res.data.data || [];

            setAssetTypes(types);
            const matchedType = types.find(
              t => t.id === itemData.assetType?.id
            );

            setAssetType(matchedType ? String(matchedType.id) : "");
          }
        );
      }
      setItemName(itemData.name);
      setAssetTag(itemData.assetTag);
      setDesc(itemData.description);
      setAssetStatus(itemData.assetStatus.id);
      setOrganization(itemData.organization.id);
      setAssignedUser(itemData.user.id);
      setLocation(itemData.location);
      setDepartment(itemData.department?.id);
      setDisposalMethod(itemData.disposalMethod?.id);
      setAssignmentType(itemData.assignmentType?.id);

      setFormData(prev => ({
        ...prev,
        name: itemData.name || "",
        description: itemData.description || "",
        assetClassId: itemData.assetClass?.id || "",
        assetTypeId: itemData.assetType?.id || "",
        organizationId: itemData.organization?.id || "",
        userId: itemData.user?.id || "",
        assetStatusId: itemData.assetStatus?.id || "",
        location: itemData.location || "",
        assetTag: itemData.assetTag || "",
        department: itemData.department || "",
        dsposalMethod: itemData.disposalMethod?.id || "",
        assignmentType: itemData.assignmentType?.id || ""

      }));

      setLifecycleData(itemData.statusDetails);
      //setExtension(itemData.extension);
      setOpen(true);
    }
    )
  };

  const saveButtonSx = {
    float: "right",
    minWidth: 150,
    marginRight: "25px",
    marginTop: "10px",
    background: "linear-gradient(45deg, #1976d2 30%, #42a5f5 90%)",
    boxShadow: "0 3px 5px 2px rgba(25, 118, 210, .3)",
    "&:hover": {
      background: "linear-gradient(45deg, #1565c0 30%, #1976d2 90%)",
    },
  };

  return (
    <ThemeProvider>
      <React.Fragment>
        {/* <Button
          variant="outlined"
          onClick={handleClickOpen}
          style={{ float: "right", margin: "5px 0px" }}
        >
          Add Asset Item
        </Button> */}
        {assetItemId === 0 ? (
          <Tooltip
            title="Add Asset Item"
            onClick={handleClickOpen}
            style={{ cursor: "pointer", margin: "2px", float: "right" }}
          >
            <IconButton>
              <AddTaskIcon color="primary" />
            </IconButton>
          </Tooltip>
        ) : (
          <Link onClick={handleClickOpen}>{selectedItemName}</Link>
        )}
        <Dialog
          open={open}
          onClose={handleClose}
          PaperProps={{
            component: "form",
            onSubmit: (event) => {
              event.preventDefault();
              (isEmpty(componentPermissions) ||
                componentPermissions?.["canUpdate"] ||
                componentPermissions?.["canCreate"]) &&
                handleSave();
              handleClose();
            },
            sx: {
              width: 600,
              // height: isEdit ? 700 : 550,
              height: "auto",
              maxWidth: "100%",
              maxHeight: "100%",
            },
          }}
        >
          <DialogTitle>{actionType} Asset Item</DialogTitle>

          <DialogContent>
            <Box
              component="form"
              sx={{
                '& .MuiTextField-root:not(.MuiAutocomplete-root .MuiTextField-root)': { width: '50ch' },
              }}
              noValidate
              autoComplete="off"
            >

              <Box sx={{ display: 'flex', gap: 2, width: '100%' }}>
                <FormControl
                  variant="outlined"
                  sx={{ minWidth: 200 }} fullWidth
                >
                  <InputLabel id="demo-simple-select-standard-label">
                    Asset Class
                  </InputLabel>
                  <Select
                    labelId="demo-simple-select-standard-label"
                    id="demo-simple-select-standard"
                    value={assetClass}
                    onChange={handleAssetClassChange}
                    label="Asset Class"
                  >
                    <MenuItem value="">
                      {' '}
                      <em>None </em>{' '}
                    </MenuItem>
                    {assetClasses.map((ac) => (
                      <MenuItem value={ac.id} key={ac.id}>
                        {ac.name}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
                <FormControl variant="outlined" sx={{ minWidth: 200 }} fullWidth>
                  <InputLabel id="demo-simple-select-standard-label" htmlFor="demo-simple-select-standard-label">
                    Asset Type
                  </InputLabel>
                  <Select
                    labelId="demo-simple-select-standard-label"
                    id="demo-simple-select-standard-label"
                    value={assetType}
                    onChange={handleAssetTypeChange}
                    label="Asset Type"
                  >
                    <MenuItem value="">
                      {" "}
                      <em>None </em>{" "}
                    </MenuItem>
                    {Array.isArray(assetTypes) &&
                      assetTypes?.map((at) => (
                        <MenuItem key={at?.id} value={String(at?.id)}>{at?.name}</MenuItem>
                      ))}
                  </Select>
                </FormControl>
              </Box>

              <Box sx={{ mb: 1, display: 'flex', gap: 2, width: '100%' }}>
                <TextField
                  fullWidth
                  autoFocus
                  required
                  margin="dense"
                  id="asset-item-name"
                  name="name"
                  label="Asset Name"
                  type="text"
                  variant="outlined"
                  value={itemName}
                  onChange={handleAssetTypeNameChange}
                />

                <TextField
                  fullWidth
                  margin="dense"
                  id="asset-item-location"
                  name="location"
                  label="Location"
                  type="text"
                  variant="outlined"
                  value={location}
                  onChange={handleLocationChange}
                />
              </Box>
              <Box sx={{ mb: 1, display: 'flex', gap: 2, width: '100%' }}>
                <FormControl variant="outlined" sx={{ minWidth: 200 }} fullWidth>
                  <InputLabel id="demo-simple-select-standard-label">
                    Assigned User
                  </InputLabel>
                  <Select
                    labelId="demo-simple-select-standard-label"
                    id="demo-simple-select-standard"
                    value={assignedUser}
                    onChange={handleAssignedUserChange}
                    label="Assigned User"
                  >
                    <MenuItem value="">
                      {" "}
                      <em>None </em>{" "}
                    </MenuItem>
                    {assignedUsers.map((user) => (
                      <MenuItem key={user.id} value={user.id}>
                        {user.name}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>

                <FormControl variant="outlined" sx={{ minWidth: 200 }} fullWidth>
                  <InputLabel id="demo-simple-select-standard-label">
                    Organization
                  </InputLabel>
                  <Select
                    labelId="demo-simple-select-standard-label"
                    id="demo-simple-select-standard"
                    value={organization}
                    onChange={handleOrganizationChange}
                    label="Organization"
                  >
                    <MenuItem value="">
                      {" "}
                      <em>None </em>{" "}
                    </MenuItem>
                    {organizations.map((org) => (
                      <MenuItem key={org.id} value={org.id}>
                        {org.name}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Box>

              <Box sx={{ mb: 2, display: "flex", width: "100%" }}>
                <TextField
                  sx={{ flexGrow: 1 }}
                  id="asset-item-description"
                  name="description"
                  label="Description"
                  placeholder="Enter Description"
                  fullWidth
                  multiline
                  rows={4}
                  variant="outlined"
                  value={desc}
                  onChange={handleDescriptionChange}
                />
              </Box>

              <Box sx={{ mb: 1, display: "flex", gap: 2, width: "100%" }}>

                <TextField
                  fullWidth
                  autoFocus
                  required
                  sx={{ minWidth: 250 }}
                  id="asset-item-tag"
                  name="assetTag"
                  label="Asset Tag"
                  type="text"
                  placeholder="Enter Asset Tag"
                  variant="outlined"
                  value={assetTag}
                  onChange={handleAssetTagChange}

                />


                <FormControl variant="outlined" fullWidth>
                  <InputLabel id="demo-simple-select-standard-label">
                    Asset Status
                  </InputLabel>
                  <Select
                    labelId="demo-simple-select-standard-label"
                    id="demo-simple-select-standard"
                    value={assetStatus}
                    onChange={handleAssetStatusChange}
                    label="Asset Status"
                  >
                    <MenuItem value="">
                      {" "}
                      <em>None </em>{" "}
                    </MenuItem>
                    {assetStatuses?.map((as) => (
                      <MenuItem key={as.id} value={as.id}>
                        {as.name}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>

              </Box>

              {dynamicFields.length > 0 && (
                <Box sx={{ mt: 2, width: "100%" }}>

                  <Typography
                    variant="subtitle1"
                    sx={{
                      mb: 2,
                      fontWeight: 600
                    }}
                  >
                    {selectedStatus?.name} Details
                  </Typography>

                  <Box
                    sx={{
                      display: "grid",
                      gridTemplateColumns: {
                        xs: "1fr",
                        md: "repeat(2, minmax(0, 1fr))"
                      },
                      gap: 2,
                      width: "100%"
                    }}
                  >
                    {dynamicFields.map((field) => (
                      <Box
                        key={field.name}
                        sx={{
                          display: "flex",
                          minWidth: 200,
                          width: "100%"
                        }}
                      >
                        <DynamicAssetField
                          field={field}
                          value={getDynamicFieldValue(field, lifecycleData[field.name])}
                          // value={lifecycleData[field.name] ?? ""}
                          onChange={handleLifecycleChange}
                          users={assignedUsers}
                          departments={departments}
                          assignmentTypes={assignmentTypes}
                          disposalMethods={disposalMethods}
                          warehouseNames={warehouseNames}
                          vendors={vendors}
                          lostTypes={lostTypes}
                          selectedTicket={
                            lifecycleData?.incidentTicketId || lifecycleData?.relatedRequestId
                              ? {
                                ticketId: lifecycleData?.incidentTicketId ||
                                  lifecycleData?.relatedRequestId,
                                name: lifecycleData?.incidentTicket || lifecycleData?.relatedRequest
                              }
                              : null
                          }
                          selectedUser={
                            lifecycleData?.reportedById || lifecycleData?.reservedForUserId || lifecycleData?.retirementApprovedById
                              ? {
                                id: lifecycleData?.reportedById || lifecycleData?.reservedForUserId || lifecycleData?.retirementApprovedById,
                                name: lifecycleData?.reportedByName || lifecycleData?.reservedForUserName || lifecycleData?.retirementApprovedByName
                              }
                              : null
                          }
                          maintenanceTypes={maintenanceTypes}
                        />
                      </Box>
                    ))}
                  </Box>

                </Box>
              )}

            </Box>
          </DialogContent>
          <DialogActions sx={{ marginBottom: "20px" }}>
            {actionType === "Add" ? (
              <Button
                variant="contained"
                type="submit"
                startIcon={<SaveIcon />}
                sx={saveButtonSx}
              >
                Save
              </Button>
            ) : null}
            {actionType === "Edit" &&
              (isEmpty(componentPermissions) ||
                componentPermissions?.["canUpdate"]) ? (
              <Button
                variant="contained"
                type="submit"
                startIcon={<SaveIcon />}
                sx={saveButtonSx}
              >
                Save
              </Button>
            ) : null}
          </DialogActions>
        </Dialog>
      </React.Fragment>
    </ThemeProvider>
  );
}
export default AssetItemDialog
